import { decodeJwtPayload } from "./product";

// Lexi Chat keys a member's conversations by their mobile. Members without one
// (a sign-up that skipped it, a Payment Link buyer who gave no phone) use their
// account ID instead, so chat works and phone-keyed histories stay as they are.
export const getChatUserId = () => {
  const phoneNumber = sessionStorage.getItem("phoneNumber");
  if (phoneNumber) return phoneNumber;
  const token = sessionStorage.getItem("authToken") || localStorage.getItem("authToken");
  return decodeJwtPayload(token)?.customerId || null;
};
